import { Box, Link, Typography } from '@mui/material'
import { Trans } from 'react-i18next'

export interface UnsavedChangesBannerProps {
  // Element id of the save button the link scrolls to.
  saveButtonId: string
}

/**
 * A quiet note at the top of a settings page that there are edits not yet saved.
 */
export const UnsavedChangesBanner = (props: UnsavedChangesBannerProps): JSX.Element => {
  const onClick = (): void => {
    document.getElementById(props.saveButtonId)?.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  return (
    <Box data-cy="box-Unsaved changes" sx={{
      mb: 2,
      px: 2,
      py: 1,
      borderRadius: '0.625rem',
      backgroundColor: 'grey.200',
      color: '#1A2026',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center',
      columnGap: 2,
    }}>
      <Typography variant="body1" sx={{ color: 'inherit' }}><Trans>You have unsaved changes</Trans></Typography>
      <Link component="button" variant="body1" onClick={onClick} data-cy="link-Go to save"
        sx={{ color: 'inherit', textDecorationColor: 'inherit' }}>
        <Trans>Go to save</Trans>
      </Link>
    </Box>
  )
}
